import {Box, Flex, Link, Text} from '@chakra-ui/react';
import {ListType} from '../../graphql/generated';
import {SubscribeSection} from '../edward8-penny/subscribe';
import {theme} from '../../style/theme';

export const OwnAPieceSoldOut = ({
  listType,
  displaySoldOutMessage,
}: {
  listType: ListType;
  displaySoldOutMessage?: boolean;
}): JSX.Element => {
  return (
    <Box
      w="100%"
      position="relative"
      marginTop={{base: '0px', md: '24px', lg: '-24px'}}
      p={{base: '0px', md: '31px'}}
      layerStyle={{base: 'none', md: 'card'}}
      borderBottomRadius="0px !important"
    >
      <Flex w="100%" align="center" justify="center">
        <Flex
          flexWrap="wrap"
          alignItems="center"
          justify="center"
          maxW="621px"
          bgColor="white"
          py="17px"
          px={{base: '16px', md: '64px'}}
          borderRadius="8px"
          border={{base: 'none', md: `1px solid ${theme.colors.aqua['500']}`}}
        >
          {displaySoldOutMessage && (
            <Text textStyle="h6" color="midGrey" mb="16px">
              Initial Offering Completed
            </Text>
          )}
          {!displaySoldOutMessage && (
            <Text textStyle="h6" color="midGrey" mb="16px">
              Initial Offering Closed
            </Text>
          )}
          {displaySoldOutMessage && (
            <Text
              textStyle="body2"
              color={theme.colors.aqua['500']}
              textAlign={{base: 'left', md: 'center'}}
              mb="24px"
            >
              All pieces have now been collected! Don’t worry, you’ll be able to
              buy from other collectors on the marketplace soon
            </Text>
          )}
          {!displaySoldOutMessage && (
            <Text
              textStyle="body2"
              color={theme.colors.aqua['500']}
              textAlign={{base: 'left', md: 'center'}}
              mb="24px"
            >
              The launch for this asset has ended! Don’t worry, you’ll be able
              to buy from other collectors on the marketplace soon
            </Text>
          )}

          <SubscribeSection
            listType={listType}
            buttonText="Notify Me"
            subscribedText="Email sent!
            You will be the first to know when the marketplace opens!"
          />
          <Text textStyle="body5" mt="8px" color="tone3">
            This will only opt you in for emails about the launch of the
            marketplace.
          </Text>
          <Text
            textStyle="body5"
            lineHeight={{base: '21px', md: '10px'}}
            fontSize={{base: '11px', md: '10px'}}
            color={{base: 'none', md: 'tone3'}}
          >
            By subscribing you agree to our
            <Link href="/privacy-policy" mx="2px">
              <a style={{color: theme.colors.aqua['500']}}>Privacy Policy</a>
            </Link>
            and
            <Link href="/terms-and-conditions" mx="2px">
              <a style={{color: theme.colors.aqua['500']}}>
                Terms and Conditions
              </a>
            </Link>
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};
